import React from 'react';
import ModalBottomSheet from './ModalBottomSheet';
import type { DateTimePickerProperties } from './properties/Properties';

/* type AwesomeDateTimePickerType = {
  multiply(a: number, b: number): Promise<number>;
}; */

// const { AwesomeDateTimePicker } = NativeModules;

// export default AwesomeDateTimePicker as AwesomeDateTimePickerType;

const AwesomeDateTimePicker = (params: DateTimePickerProperties) => {
  return (
    <ModalBottomSheet
      {...params} />
  );
}

export default AwesomeDateTimePicker;
